/* Product page helpers: sticky add-to-cart bar. */
if (!customElements.get('q-sticky-atc')) {
  customElements.define(
    'q-sticky-atc',
    class QStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.select = this.querySelector('[data-q-sticky-select]');

        if (this.dataset.display !== 'always' && this.mainButton) {
          // Show the bar once the main add-to-cart button has scrolled up out of view.
          this.onScroll = () => {
            const passed = this.mainButton.getBoundingClientRect().bottom < 0;
            if (passed !== this.classList.contains('is-visible')) this.toggle(passed);
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.onScroll();
        } else if (this.dataset.display !== 'always') {
          this.toggle(true);
        }

        if (this.select) {
          this.select.addEventListener('change', () => this.onSelect());
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }
      }

      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
        if (this.unsubscribe) this.unsubscribe();
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.querySelectorAll('button, select').forEach((el) => {
          if (show) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      }

      onSelect() {
        const form = document.getElementById(`product-form-${this.sectionId}`);
        if (!form) return;
        const input = form.querySelector('input[name="id"]');
        if (input) {
          input.value = this.select.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const option = this.select.selectedOptions[0];
        const button = this.querySelector('button[name="add"]');
        if (button && option) {
          button.disabled = option.disabled;
        }
      }

      onVariantChange(event) {
        const data = event && event.data;
        if (!data || data.sectionId !== this.sectionId || !data.variant) return;
        if (this.select) this.select.value = data.variant.id;
        const button = this.querySelector('button[name="add"]');
        if (button) {
          button.disabled = !data.variant.available;
          const label = button.querySelector('span');
          if (label) {
            label.textContent = data.variant.available
              ? button.dataset.addLabel || window.variantStrings.addToCart
              : window.variantStrings.soldOut;
          }
        }
        if (data.html) {
          const fresh = data.html.querySelector(`#StickyAtc-${this.sectionId} [data-q-sticky-price]`);
          const current = this.querySelector('[data-q-sticky-price]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
      }
    }
  );
}
